import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Routing
import { LoginRoutingModule } from './login-routing.module';
// Modulo Shared
import { SharedModule } from './../shared/shared.module';
// Componentes
import { LoginPageComponent } from './login-page/login-page.component';
import { ModalEnvioCodigoComponent } from './components/modal-envio-codigo/modal-envio-codigo.component';
import { PasswordFirstTimeComponent } from './components/password-first-time/password-first-time.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';

@NgModule({
  declarations: [LoginPageComponent, ModalEnvioCodigoComponent, PasswordFirstTimeComponent, RecoverPasswordComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    SharedModule
  ],
  entryComponents: [
    ModalEnvioCodigoComponent,
    PasswordFirstTimeComponent,
    RecoverPasswordComponent
  ]
})
export class LoginModule { }
